import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import styled from '@emotion/styled';

interface Props {
  sectionName?: string;
}

const HeaderText = styled.h1`
  text-overflow: ellipsis;
  overflow: hidden;
  @media (max-width: 480px) {
    display: none;
  }
`;

function TopSection(props: Props): JSX.Element {
  const location = useLocation();

  const isCollectionPage = location.pathname.includes('/launchpad/');

  const Section = useMemo(
    () => styled.div`
      @media (max-width: 480px) {
        padding: 0 0 0 0 !important;
        height: 0;
        margin-bottom: 20px;
      }
      padding: ${isCollectionPage ? '30px 0 0 0 !important' : ''};
    `,
    [isCollectionPage]
  );

  return (
    // id for each theme can custom the banner image
    <Section
      className="flat-title-page inner"
      id={`${location.pathname}-banner`}
    >
      <div className="overlay" />
      <div className="themesflat-container">
        <div className="row">
          <div className="col-md-12">
            <div className="page-title-heading mg-bt-12">
              <HeaderText
                className="heading text-center"
                data-test="header-title"
              >
                {props.sectionName || '\u00A0'}
              </HeaderText>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default TopSection;
